module.exports = "/assets/js/86f0397c7556405df67707cc5284464c.svg";